import { z } from 'zod'
import { oc } from '@orpc/contract'
import { billingEntrySchema, billingSuggestionSchema } from '../soap-note-payload.contract'

export const updateBillingResponseSchema = z.object({
  claimId: z.string(),
  documentReferenceId: z.string().optional(),
  updatedAt: z.string(),
})
export type UpdateBillingResponse = z.infer<typeof updateBillingResponseSchema>

export const visitUpdateBilling = oc
  .route({ method: 'PATCH', path: '/v2/visits/{encounterId}/billing' })
  .input(
    z.object({
      encounterId: z.string(),
      billing: z.array(billingEntrySchema),
      billingSuggestion: billingSuggestionSchema.optional(),
      selectedCoverageId: z.string().optional(),
      /** PD-1597 — a billing administrator's reason for saving a $0 submitted charge. */
      zeroChargeOverride: z.object({ reason: z.string().trim().min(10) }).optional(),
    }),
  )
  .output(updateBillingResponseSchema)
